import type { SearchProductList } from '@/components/TripActivity/types'
import fetchRecentTripSearches, {
  type ApiMetadata,
  type RequestOptions,
} from '@/shared-utils/fetchRecentTripSearches'
import { useQuery } from '@tanstack/react-query'
import useSeti from './useSeti'

export default function useRecentSearchCard(
  cguid: string,
  apiMetadata: ApiMetadata,
  searchProducts: SearchProductList,
  signedIn: boolean,
) {
  const isRecentSearchRelevanceSeti =
    useSeti({ experimentCode: 'HP_RECENTSEARCH_RELEVANCY', shouldFireImpression: true }) === 'VARIANT'
  const shouldHideBookedSearches =
    useSeti({ experimentCode: 'HP_PUWYLO_HIDE_BOOKED_SEARCHES', shouldFireImpression: true }) === 'VARIANT'

  const requestOptions: RequestOptions = {}

  if (isRecentSearchRelevanceSeti) requestOptions.sortOrder = 'RELEVANCE'
  if (shouldHideBookedSearches) requestOptions.unbookedSelectionsOnly = true

  const { data = [] } = useQuery({
    queryKey: [searchProducts, cguid, apiMetadata, signedIn, requestOptions, 'recent-searches'],
    queryFn: () => fetchRecentTripSearches(cguid, apiMetadata, searchProducts, signedIn, requestOptions),
    staleTime: Infinity,
  })

  return data
}
